import { Notification } from "@/components/common";
import { useUserStore } from "@/states/zustand/user";
import { Navigate, Outlet } from "react-router";

export function AuthLayout() {

    const jwt = useUserStore(state => state.jwt);

    if (jwt && jwt.token) return <Navigate to={"/"} replace />;

    return (
        <section
            className=" min-h-screen flex items-center justify-center bg-[url(/assets/login_bg_image.jpg)] bg-center bg-cover bg-no-repeat"
        >
            <Notification
                layoutType="auth"
            />
            <Outlet />
        </section>
    )
}